import { render, staticRenderFns } from "./CustomerSubscriptions.vue?vue&type=template&id=9a53117a&scoped=true"
import script from "./CustomerSubscriptions.vue?vue&type=script&lang=js"
export * from "./CustomerSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./CustomerSubscriptions.vue?vue&type=style&index=0&id=9a53117a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a53117a",
  null
  
)

export default component.exports